import axios from "utils/axios";

export const getCountries = (params) => {
  return axios.get('/countries', { params });
};